export const SAGE_COMPANY_ID = 672259;
